import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { Modal, Button } from "antd";
import { ModalConstants } from "../../../../common/Constants";

export interface State {}

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onCancel: any;
  onCreate: any;
  Form: any;
  codebooks?: any;
}

export default class CreateModal extends React.Component<Props, State> {
  private formSubmitHandler: any;

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.registerFormSubmitEventHandler = this.registerFormSubmitEventHandler.bind(
      this
    );
  }

  registerFormSubmitEventHandler(registrationHandler) {
    this.formSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const { onCreate, onCancel } = this.props;
    if (this.formSubmitHandler) {
      let newData = this.formSubmitHandler(e);
      if (newData) {
        onCreate(newData);
        onCancel();
      }
    }
  }

  render() {
    const { translate, title, visible, onCancel, Form, codebooks } = this.props;

    return (
      <div>
        <Modal
          title={title ? title : ""}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.insert_modal.cancel")}
            </Button>,
            <Button key="submit" type="primary" onClick={this.onSubmit}>
              {translate("modal_functions.insert_modal.add")}
            </Button>
          ]}
          width={ModalConstants.WIDTH}
        >
          <Form
            translate={translate}
            registerFormSubmitEventHandler={this.registerFormSubmitEventHandler}
            codebooks={codebooks}
            onCancel={onCancel}
          />
        </Modal>
      </div>
    );
  }
}
